export const CHANGE_EDITOR_FOCUS = 'editor/CHANGE_EDITOR_FOCUS'
export const SET_EDITOR_MODE = 'editor/SET_EDITOR_MODE'
